var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dry-lastYear"},[_c('moduleTitle',{attrs:{"type":"dw","title":"农业标准地情况"}}),_c('div',{staticClass:"dry-lastYear-content"},[_c('div',{staticClass:"lastYear-content-echart"},[_c('myCharts',{attrs:{"pdata":_vm.listData}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }